import{jsx as r}from"react/jsx-runtime";var e=function(e){var t=e.fileData;return r("pre",{children:t})};export{e as TextViewer};
